module.exports = __webpack_public_path__ + "static/media/unitelmasapienza.ce725ae3.png";